module.exports = __webpack_public_path__ + "img/2_8.a6e44afb.png";